<div class="uk-container uk-container-expand">
  <div class="uk-grid">
    <div class="uk-width-1-1 uk-margin-medium-top uk-margin-small-bottom">
      <h2 class="primary-color uk-text-bold">MES STATISTIQUES</h2>
    </div>
  </div>

  <div class="uk-grid uk-grid-small uk-width-4-5 uk-margin-top uk-margin-medium-bottom">
    <div class="uk-width-1-1">
      <p class="uk-margin-remove">Période</p>
    </div>
    <div class="uk-margin-medium-right">
      <kendo-dropdownlist
        (selectionChange)="changePeriod($event)"
        [data]="listOfPeriod"
        [textField]="'libelle'"
        [valueField]="'code'"
        [value]="listOfPeriod[0]"
      >
      </kendo-dropdownlist>
    </div>

    <div>
      <p style="margin-top: 6px">DU</p>
    </div>

    <div>
      <kendo-datepicker
        [disabled]="!selectPeriodChecker"
        [format]="'dd/MM/yyyy'"
        [(value)]="dateBeginPeriod"
        (valueChange)="changeBeginDate($event)"
        (change)="changeBeginDate($event)"
      ></kendo-datepicker>
    </div>

    <div>
      <p style="margin-top: 6px">AU</p>
    </div>

    <div>
      <kendo-datepicker
        [disabled]="!selectPeriodChecker"
        [format]="'dd/MM/yyyy'"
        [(value)]="dateEndPeriod"
        (change)="changeEndDate($event)"
        (valueChange)="changeEndDate($event)"
      ></kendo-datepicker>
    </div>
  </div>

  <div class="uk-grid" [hidden]="getMoreFilter">
    <div>
      <p class="uk-margin-remove">Produits</p>
      <kendo-multiselect
        style="width: 220px!important;"
        (valueChange)="getFilterSelector($event, 'produit')"
        [filterable]="true"
        [data]="listProduits"
        [textField]="'libelle'"
        [valueField]="'id'"
      >
      </kendo-multiselect>
    </div>

    <div>
      <p class="uk-margin-remove">Secteur</p>
      <kendo-multiselect
        (valueChange)="getFilterSelector($event, 'secteur')"
        style="width: 220px!important;"
        [filterable]="true"
        [data]="listSector"
        [textField]="'libelle'"
        [valueField]="'id'"
      >
      </kendo-multiselect>
    </div>

    <div>
      <p class="uk-margin-remove">Famille</p>
      <kendo-multiselect
        (valueChange)="getFilterSelector($event, 'famille')"
        style="width: 220px!important;"
        [filterable]="true"
        [data]="listFamile"
        [textField]="'libelle'"
        [valueField]="'id'"
      >
      </kendo-multiselect>
    </div>
    <br />

    <div [ngClass]="!isInter && !isBigScreen ? 'margin-top-22' : ''">
      <p class="uk-margin-remove">Groupe</p>
      <kendo-multiselect
        (valueChange)="getFilterSelector($event, 'groupe')"
        style="width: 220px!important;"
        [filterable]="true"
        [data]="listGroup"
        [textField]="'libelle'"
        [valueField]="'id'"
      >
      </kendo-multiselect>
    </div>
  </div>
  <div class="uk-width-1-1 uk-margin-small-bottom uk-margin-medium-top">
    <span> Status des session</span>
  </div>
  <div class="uk-grid">
    <div class="uk-width-1-2">
      <div class="uk-grid-small uk-margin-medium-bottom">
        <div class="listOfButton" *ngFor="let status of statut_session">
          <button
            (click)="selectStatut(status)"
            [togglable]="true"
            [ngClass]="status.couleur"
            kendoButton
            class="k-text-uppercase filterButton"
          >
            {{ status.libelle | uppercase }}
          </button>
        </div>
      </div>
    </div>
    <div class="uk-width-1-2">
      <div class="uk-flex uk-flex-right">
        <button kendoButton (click)="moreFilter()" [look]="'outline'" class="hideInput k-text-uppercase">
          <ng-container *ngIf="!getMoreFilter; else moreFilterTemplate">
            moins de filtres
          </ng-container>
          <ng-template #moreFilterTemplate>
            plus de filtres
          </ng-template>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="data">
    <div class="uk-grid">
      <div class="uk-width-1-3">
        <argalis-apps-static-ca-card
          *ngIf="cardVisualisation.ca"
          [caData]="data"
          [isInter]="isInter"
          [indicator]="indicator"
        >
        </argalis-apps-static-ca-card>
        <argalis-apps-static-marge-card
          *ngIf="cardVisualisation.marge"
          [margeData]="data"
          [indicator]="indicator"
        ></argalis-apps-static-marge-card>
        <argalis-apps-statisfaction-card
          [statisfactionData]="data"
          *ngIf="cardVisualisation.satisfaction"
          [indicator]="indicator"
        ></argalis-apps-statisfaction-card>
      </div>
      <div class="uk-width-1-3">
        <argalis-apps-static-stagiare-card
          [stagiareData]="data"
          [isInter]="isInter"
          *ngIf="cardVisualisation.stagiare"
          [indicator]="indicator"
        ></argalis-apps-static-stagiare-card>
      </div>
      <div class="uk-width-1-3">
        <argalis-apps-static-session-card
          *ngIf="cardVisualisation.session"
          [sessionData]="data"
          [indicator]="indicator"
        >
        </argalis-apps-static-session-card>
      </div>
    </div>

    <argalis-apps-static-inter-cards
      *ngIf="isInter"
      [interStaticData]="data"
      [indicator]="indicator"
      [cardVisulisation]="cardVisualisation"
    ></argalis-apps-static-inter-cards>
  </div>
  <lib-ags-loading *ngIf="!data"></lib-ags-loading>
</div>
